module.exports = __webpack_public_path__ + "img/whatsapp.b9c75ef1.svg";